export default __webpack_public_path__ + "partner_106ada79.png";